/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Inventor Automation team
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Tabs, { Tab } from "@hig/tabs";
import ProjectList from './projectList';
import Products from './Products/Products';
import ForgeView from './forgeView';
import ParametersContainer from './parametersContainer';
import Bom from './bom';
import Downloads from './downloads';
import RfqManager from './RfqManager';
import Settings from './Settings';
import UserManagement from './UserManagement';
import ProductManager from './ProductManager';
import EventViewer from './EventViewer/EventViewer';
import SystemAdminDashboard from './SystemAdminDashboard/SystemAdminDashboard';
import './tabs.css';
import { embeddedModeEnabled, activeTabIndex } from '../reducers/mainReducer';
import { updateActiveTabIndex } from '../actions/uiFlagsActions';
import Drawing from './drawing';
import authService from '../services/authService';
import Wizard from './Wizard/Wizard';

export class TabsContainer extends Component {
    onTabChange(index) {
      this.props.updateActiveTabIndex(index);
    }
    
    render() {
        const idx = this.props.activeTabIndex;
        const showProjectsTab = this.props.embeddedModeEnabled;
        const showParameters = this.props.embeddedModeEnabled;
        const isAdmin = authService.isAdmin();
        const user = authService.getCurrentUser();
        const isSystemAdmin = user && user.role === 'System Administrator';

        // Determine user type for tab visibility
        // Sales and Customer see Products tab with card grid
        // Admins see both Products (for browsing) and Product Manager (for uploading)
        const userRole = user?.role || '';
        const isSalesOrCustomer = userRole === 'Sales' || userRole === 'Customer';

        // Non-admin users get the guided wizard flow instead of flat tabs
        if (!isAdmin && !showProjectsTab) {
            return (
                <div className="tabsContainer">
                    <Wizard
                        onCartUpdated={this.props.onCartUpdated}
                        isAnonymous={this.props.isAnonymous}
                        hideQuoteButtons={this.props.hideQuoteButtons}
                    />
                </div>
            );
        }

        return (
            <div className="tabsContainer">
            <Tabs
              className="fullheight"
              align="center"
              showTabDivider={false}
              onTabChange={(index) => { this.onTabChange(index); }}
              onTabClose={() => {}}
              activeTabIndex={idx}
            >
              {/* Products tab - shown to everyone */}
              {!showProjectsTab &&
                <Tab label="Products">
                  <div id="products" className="tabContent fullheight">
                    <Products/>
                  </div>
                </Tab>
              }
              
              {/* Product Configurator - shown to everyone */}
              <Tab label="Product Configurator" >
                <div id="model" className='tabContent fullheight'>
                  <div className='inRow fullheight'>
                    { !showParameters &&
                      <ParametersContainer
                        onCartUpdated={this.props.onCartUpdated}
                        isAnonymous={this.props.isAnonymous}
                        hideQuoteButtons={this.props.hideQuoteButtons}
                      />
                    }
                    <ForgeView/>
                  </div>
                </div>
              </Tab>
              
              {/* BOM - shown to everyone */}
              <Tab label="BOM">
                <div id="bom" className="tabContent fullheight">
                  <Bom/>
                </div>
              </Tab>
              
              {/* Drawing - shown to everyone */}
              <Tab label="Drawing">
                <div id="drawing" className="tabContent fullheight">
                  <Drawing/>
                </div>
              </Tab>
              
              {/* Downloads - shown to everyone */}
              <Tab label="Downloads">
                <div id="downloads" className="tabContent fullheight">
                  <Downloads/>
                </div>
              </Tab>
              
              {/* Product Manager - Admins only (for uploading/managing products) */}
              {isAdmin &&
                <Tab label="Product Manager">
                  <div id="product-manager" className="tabContent fullheight">
                    <ProductManager/>
                  </div>
                </Tab>
              }
              
              {/* RFQ Manager - Admins only */}
              {isAdmin &&
                <Tab label="RFQ Manager">
                  <div id="rfq-manager" className="tabContent fullheight">
                    <RfqManager/>
                  </div>
                </Tab>
              }
              
              {/* Users - Admins only */}
              {isAdmin &&
                <Tab label="Users">
                  <div id="user-management" className="tabContent fullheight">
                    <UserManagement/>
                  </div>
                </Tab>
              }
              
              {/* Event Log - Admins only */}
              {isAdmin &&
                <Tab label="Analytics">
                  <div id="event-viewer" className="tabContent fullheight">
                    <EventViewer/>
                  </div>
                </Tab>
              }
              
              {/* System Admin - System Administrator only */}
              {isSystemAdmin &&
                <Tab label="System Admin">
                  <div id="system-admin" className="tabContent fullheight">
                    <SystemAdminDashboard/>
                  </div>
                </Tab>
              }
              
              {/* Settings - Admins only */}
              {isAdmin &&
                <Tab label="Settings">
                  <div id="settings" className="tabContent fullheight">
                    <Settings/>
                  </div>
                </Tab>
              }
            </Tabs>
          </div>
        );
    }
}

/* istanbul ignore next */
export default connect(function (store){
  return {
    activeTabIndex: activeTabIndex(store),
    embeddedModeEnabled: embeddedModeEnabled(store)
  };
}, { updateActiveTabIndex } )(TabsContainer);